import React from 'react'
import SelectionManagement from '../components/SelectionManagement/SelectionManagement'

const SelectionManagementPage = () => {
  return (
    <>
      <SelectionManagement />
    </>
  )
}

export default SelectionManagementPage
